import "./index.css"
export default function index() {
  return (
    <>
        <div className="about-us-page">
            <span>---------ABOUT US-----------</span>
            <h1>About Us </h1>
            <h3>Empowering learners with cutting-edge technology skills</h3>
        </div>
    </>
  )
}